import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const publishDate: AdminBlockTypeAttribute = {
  label: 'Show publish date',
  key: 'publishDate',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default publishDate;
